import { List, ListItemText } from 'appkit-react';

import ArchiveProject from '../ArchiveProject';

const MenuTooltip = ({
    data, setShowModal, setDataForUpdate, setDataForClone,
    setCopyProjectFlag, tenantId, getProjectHierarchy, setToastMessage,
}) => (
    <div>
        <List>
            <ListItemText
                onClick={
                    () => {
                        setShowModal(true);
                        setDataForUpdate(data);
                        setDataForClone({});
                    }
                }
            >
                Edit
            </ListItemText>
            <ListItemText onClick={() => {
                setShowModal(true);
                setDataForClone(data);
                setCopyProjectFlag(true);
                setDataForUpdate({});
            }}
            >
                Clone
            </ListItemText>
            <ArchiveProject tenantId={tenantId} project={data} fetchData={getProjectHierarchy.refetch} setToastMessage={setToastMessage} />
        </List>
    </div>
);

export default MenuTooltip;
